import { memo } from 'react';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { createMarkup } from 'lib/utils/create-markup';
import styled from 'styled-components';
import { Fontw35s30h40 } from 'styles/commonCss';
import { mqTabletMax } from 'styled/tools/media-queries';

type Props = {
  content: any;
};

const TermsDesktop = memo(({ content }: Props) => {
  const MainWrapper = styled.div`
    display: flex;
    margin: 0 auto;
    width: 50%;

    @media ${mqTabletMax} {
      width: 100%;
    }
  `;

  const MainSection = styled.section`
    display: flex;
    flex-direction: column;

    margin: 5rem 2rem 0 2rem;

    h1 {
      ${Fontw35s30h40}
      display: block;
      margin-bottom: 3rem;
      width: 80%;
    }
    p {
      display: block;
      padding: 0.75rem 0;
      &:empty {
        padding: 30px 0 0;
      }
    }
    * {
      color: var(--text-primary);
    }
    ul,
    ol {
      list-style-type: disc;
      li {
        p {
          padding: 0;
          display: inline;
        }
      }
    }
  `;

  return (
    <MainWrapper>
      <MainSection
        dangerouslySetInnerHTML={createMarkup(
          documentToHtmlString(content).replace(/\n/g, '<br/>'),
        )}
      />
    </MainWrapper>
  );
});

export default TermsDesktop;
